<template>
  <div>
    <a-skeleton active :loading="loadTag"/>

    <div v-show='!loadTag'>
        <div class="trainInfo">
          <div class="title">车次信息<span style='color:red'>（ 抢票 ）</span></div>
                <a-row class="main">
                    <a-col :span="13">
                        <div class="top">
                            <div>出发日期</div> <span>{{detail.chooseDates.split('|').join('，')}}</span>
                        </div>
                        <div class="top">
                             <div>出行乘客</div><span>{{extract(detail)}}</span>
                        </div>
                        <div class="top">
                            <div>备选车次</div><span>{{detail.chooseTrains.split('|').join('，')}}</span>
                        </div>
                        <div class="top">
                            <div>备选坐席</div><span>{{detail.chooseSeatClassVal.split('|').join('，')}}</span>
                        </div>
                        <div class="top" style='margin-bottom:0'>
                            <div>截止时间</div><span>{{detail.expiryTime}}</span>
                        </div>
                    </a-col>
                    <a-col :span="11"  class='loading_cont'>
                        <a-button type="primary" class='loading_btn' :class='{t30:detail.state == 20,t80:detail.state == 80,t90:detail.state == 90}'  :loading='detail.state == 20' v-if='detail.payStateVal == 20'>
                            {{detail.state == 20?'高速抢票中':detail.stateVal}}
                        </a-button>

                        <a-button type="primary" class='loading_btn conclick' :class='{t30:detail.state == 20,t80:detail.state == 80,t90:detail.state == 90}'  :loading='detail.state == 20' v-else @click='topay'>
                            {{detail.payStateVal}}
                        </a-button>

                    
                    </a-col>
            </a-row>
        </div>
        <div class="money_content">
            <div>
                <div class="price" >
                    <div>火车票（ 按最高票价全额计算 ）</div>
                    <div class='light'>¥{{detail.ticketAmount}}</div>
                </div>
                <div class="price" >
                    <div>手续费</div>
                    <div class='light'>¥{{detail.serviceAmount}}</div>
                </div>
                <div class="price" v-if='detail.insuranceAmount'>
                    <div>保险费</div>
                    <div class='light'>¥{{detail.insuranceAmount}}</div>
                </div>


                

                <div class="price_totle">
                    <div>共计票款</div>
                    <div style="color: #fd5739">¥{{detail.totalAmount}}</div>
                </div>
            </div>
        </div>

        <div class="confirm_order" v-if='detail.state == 20'>
          <a-button type="primary" class='concelBtn' @click='concel_rob'>
            取消抢票
          </a-button>
        </div>
        <div class="confirm_order" v-if='detail.state == 10 && detail.payState == 10'>
          <a-button type="primary" @click='topay'>
            立即支付
          </a-button>
        </div>
    </div>

  </div>
</template>
<script>
import { ref, watch,nextTick } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import { MailOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons-vue'
import homeApi from '@axios/home'
import { Modal,message } from 'ant-design-vue'

export default {
  name: 'robDetail',
  components: {


  },
  setup () {
    let router = useRouter()
    const route = useRoute()


    let detail = ref({
        chooseDates : '',
        chooseTrains : '',
        rushTicketOrderPassengersBoList : [],
        chooseSeatClassVal : ''
    })
    let loadTag = ref(true);
    const getDetail = () => {
        homeApi.robOrderDetail(route.query.code).then((res)=>{
            // res.state = 20
            detail.value = res;
            loadTag.value = false
        })
    }

    getDetail();

    const extract = (item) => {
      let arr = item.rushTicketOrderPassengersBoList.map((ele)=>{
        return ele.passengerName
      })
      return arr.join('，')
    }

    const concel_rob = () => {
        Modal.confirm({
            content: '您确认要取消抢票单么?',
            onOk() {
                homeApi.robCancel(route.query.code).then((res)=>{
                    router.replace({
                      name : 'orderList'
                    })
                })
            },
            cancelText: "取消",
            okText: "确定",
            onCancel() {
                Modal.destroyAll();
            },
        });

    }

    const topay = () => {
      let paypa = {
          orderCode : detail.value.orderCode,
          appPlatform : 10,
          returnUrl : window.location.origin + '/train_pc/robDetail?code=' + detail.value.orderCode
      }

      homeApi.robToPay(paypa).then((rest)=>{
          window.location.href = rest.cashierUrl + '?advanceOrderNo=' + rest.advanceOrderNo + '&type=train'
      })
    }


    return {
        topay,
        concel_rob,
        extract,
        loadTag,
        detail,

    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.conclick{
  cursor: pointer!important;
}
.money_content{
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;

    .price,.price_totle{
        display: flex;
        width: 335px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        justify-content: space-between;
        line-height: 30px;
        border-bottom:0.5px dashed #BDC0C8;
        padding:5px 0;
    }
    .price{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .price_totle{
        border: none;

        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000000;
    }
}
.totle_price{
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.regular{

  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.confirm_order{
  margin-top: 100px;
  display: flex;
  justify-content: flex-end;
  .submitBtn,.concelBtn{
    width: 167px;
    height: 40px;

  }
  .submitBtn{
    background: #FFAB00;
    border-color:#FFAB00;
    margin-right: 17px;
  }
  .concelBtn{
    background: #F8F8F8;
    border-color:#F8F8F8;
    color:#000000;
  }
}

.loading_cont{
    margin-top:30px;
  ::v-deep(.ant-btn.ant-btn-loading)::before {
      display: none!important;
  }
}

.loading_btn{
    background: #FFAB00;
    border-color:#FFAB00;
    width: 125px;
    height: 35px;
    cursor: default;
}

.t30{
    background: #00b54f;
    border-color:#00b54f;
}

.t80,.t90{
    background: #929292;
    border-color:#929292;
}

.loading_cont{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.endorse_cont{
  margin-top: 100px;
}
.grayClass{
  color:#DEDFE3!important;
  .price,.type{
    color:#DEDFE3!important;
  }
}
.name{
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-family: PingFangSC-Medium, PingFang SC;
  span{
    margin-right: 10px;
  }
}
.orderDetail {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.topTitle {
  line-height: 20px;
  margin-bottom: 20px;
  span {
    margin: 0 2px;
  }
}

.trainInfo {
  border: 0.5px solid #cdcccd;
  .title {
    height: 68px;
    line-height: 68px;
    font-size: 16px;
    padding-left: 26px;
    border-bottom: 0.5px solid #cdcccd;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .main {
    padding: 15px 33px;
    display: flex;
    justify-content: flex-start;
    // height: 180px;

    .ant-col-13 {
      border-right: 0.5px solid #cdcccd;
      .top {
        margin-bottom: 13px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        display: flex;
        &>div{
          width: 70px;
        }
        span{
            flex:1;
            font-size: 16px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 300;
            color: #000000;
            margin-left: 30px;
        }
      }
      .box {
        padding-right: 40px;
        .time {
          line-height: 28px;
          margin-bottom: 8px;

          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .city {
          line-height: 22px;

          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .maiddle {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          &>img{
            width: 95px;
          }
          .runTime {
            font-size: 14px;
            line-height: 20px;
            color: #000000;

            font-family: PingFangSC-Light, PingFang SC;
            img{
              width: 17px;
              position: relative;
              top:-1px;
            }
          }
          .trainNo {
            line-height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FD5839;
          }
        }
        .right {
          text-align: right;
        }
      }
      .bottom {
        padding-right: 40px;
        text-align: right;
        margin-top: 18px;
        span {
          font-size: 12px;
          color: #3999fb;
          border: 0.5px solid #3999fb;
          border-radius: 10px;
          padding: 1px 8px;
        }
      }
    }
    .ant-col-11 {
      padding: 31px 47px;
      .item {
        line-height: 26px;
        margin-bottom: 8px;
        .price {
          text-align: right;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #000000;
        }
      }
    }
  }
}
.passengerInfo {
  background: rgba(248, 248, 248, 1);
  padding: 20px 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  .title {
    padding-right: 47px;
    .title-left {
      font-size: 16px;
      line-height: 22px;
      padding: 0 21px;
      margin-bottom: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .title-right {
      text-align: right;
      .change {
        font-size: 14px;
        cursor: pointer;
      }
      .line {
        margin: 0 20px;
        color: rgba(0, 0, 0, 0.35);
      }
      .choosed {
        color: #ffab00;
        text-decoration: underline;
      }
      .refund{
        cursor: pointer;
      }
    }
  }
  .main {
    padding: 5px 47px 5px 21px;
    // height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-bottom: 0.5px dashed rgba(189, 192, 200, 0.5);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #000000;
    &:last-of-type {
      border-bottom: none;
    }
    .type {
      font-size: 12px;
      color: #6d7278;
    }
    .price {
      text-align: right;
      color: #ff0000;

      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
.noendorse{
  color:#DEDFE3!important;
}
.bottomInfo {
  text-align: right;
  margin: 20px 0 60px 0;
  .handleBtn {
    display: inline-block;
    padding: 9px 50px;
    background: #ffab00;
    font-size: 16px;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
